<template>
  <div id="app">
    <!-- <div class="tops"></div> -->
    <div class="body">
      <!-- <transition mode="out-in"> -->
      <!-- <keep-alive> -->
      <router-view></router-view>
      <!-- </keep-alive> -->
      <!-- </transition> -->

    </div>
  </div>
</template>

<script>

export default {
  name: 'app',
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// App.vue?72927615